import React, { useEffect, useMemo, useState } from 'react';
import { Icon } from '@iconify/react';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { useAuth } from '../contexts/AuthContext';
import { useUserGroup } from '../contexts/UserGroupContext';
import { userNav } from '../components/NavigationPath';
import Loader from '../components/Loader';
import Layout2 from '../components/Layout2';
import PageHeader from '../components/PageHeader';
import AddUserGroup from '../components/AddUserGroup';
import InfiniteScroll from 'react-infinite-scroll-component';

const UserGroup = () => {
    const { toast, restaurantId, auth, hasPermission } = useAuth();
    const { getAllUserGroups, getSingleUserGroups } = useUserGroup();

    // const canCreate = useMemo(() => hasPermission("users", "create"), [hasPermission]);
    // const canUpdate = useMemo(() => hasPermission("users", "update"), [hasPermission]);
    // const canDelete = useMemo(() => hasPermission("users", "delete"), [hasPermission]);

    const [visible, setVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userGroupList, setUserGroupList] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editUserGroupId, setEditUserGroupId] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalRenderedRecords, setTotalRenderedRecords] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [userGroupDetail, setUserGroupDetail] = useState({
        name: '',
        role: '',
        info: '',
        role_access: null,
    });
    const [filter, setFilter] = useState({
        limit: 50,
        filter: null,
        restaurant_id: null,
        totalRenderedRecords: 0,
    });

    // const handleClose = () => {
    //     setVisible(false);
    //     setEditMode(false);
    //     setEditUserGroupId(null);
    //     setUserGroupDetail({
    //         name: '',
    //         role: '',
    //         info: '',
    //         role_access: null,
    //     })
    // };

    useEffect(() => {
        if (restaurantId) {
            handleFilterChange({ ...filter, restaurant_id: restaurantId })
        }
    }, [restaurantId])

    const handleFilterChange = async (newFilter) => {
        setUserGroupList([]);
        setFilter({ ...newFilter, totalRenderedRecords: 0, });
        setHasMore(true);
    };

    useEffect(() => {
        if (filter) {
            fetchUserGroups(filter);
        }
    }, [filter]);

    const fetchUserGroups = async (filter) => {
        try {
            if (restaurantId) {
                setIsLoading(true)

                const data = await getAllUserGroups(filter);
                if (data.userGroups.length !== 0 && data.totalCount !== userGroupList.length) {
                    setUserGroupList([...userGroupList, ...data.userGroups]);
                    setTotalRecords(data.totalCount)
                    setTotalRenderedRecords(userGroupList.length)
                }

                setIsLoading(false)
            }
        } catch (error) {
            console.error('Error fetching user groups', error);
        }
    };

    const handleLoadMore = () => {
        if (userGroupList.length === totalRecords) {
            setHasMore(false);
        } else if (userGroupList.length === filter.limit) {
            const updatedFilter = { ...filter, totalRenderedRecords: filter.limit };

            setFilter(updatedFilter);
            setTotalRenderedRecords(updatedFilter.totalRenderedRecords);
        } else {
            const updatedFilter = { ...filter, totalRenderedRecords: totalRenderedRecords + filter.limit };

            setFilter(updatedFilter);
            setTotalRenderedRecords(updatedFilter.totalRenderedRecords);
        }
    };

    const fetchUserGroupsProps = async (newUserGroupId) => {
        try {
            if (editMode && editUserGroupId) {
                const userGroup = await getSingleUserGroups(editUserGroupId);
                const userGroupIndex = userGroupList.findIndex((u) => u.id === editUserGroupId);

                if (userGroupIndex !== -1) {
                    if (!userGroup) {
                        const updatedUserGroupList = [...userGroupList];
                        updatedUserGroupList.splice(userGroupIndex, 1);

                        setUserGroupList(updatedUserGroupList);
                        setTotalRecords(totalRecords - 1);
                        setTotalRenderedRecords(totalRenderedRecords - 1)
                    } else {
                        const updatedUserGroupList = [...userGroupList];
                        updatedUserGroupList[userGroupIndex] = userGroup;

                        setUserGroupList(updatedUserGroupList);
                    }
                } else {
                    setUserGroupList([...userGroupList, userGroup]);
                }
            } else if (visible) {
                const updatedUserGroupList = [...userGroupList];
                updatedUserGroupList.unshift({ ...userGroupDetail, id: newUserGroupId });

                setUserGroupList(updatedUserGroupList);
                setTotalRecords(totalRecords + 1);
                setTotalRenderedRecords(totalRenderedRecords + 1)
            }
        } catch (error) {
            console.error('Error fetching user group.', error);
        }
    };

    const renderCardsInRows = () => {
        const rows = [];
        let currentRow = [];
        let count = 0;

        userGroupList && userGroupList.forEach((userGroup, index) => {
            currentRow.push(
                <div key={userGroup.id} className="d-flex">
                    <Card
                        title={
                            <div className='product-name' title={userGroup.name  + " - " + userGroup.role}>
                                {userGroup.name}
                            </div>
                        }
                        header={<Icon icon="solar:user-id-bold-duotone" width={80} height={80} />}
                        className="card"
                        // onClick={() => {
                        //     if(!canUpdate && !canDelete) return;
                        //     setEditMode(true);
                        //     setEditUserGroupId(userGroup.id);
                        // }}
                    />
                </div>
            );

            count++
            rows.push(
                <div key={index} className="d-flex">
                    {currentRow}
                </div>
            );
            currentRow = [];
            count = 0
        });

        return rows;
    };

    return (
        <Layout2 items={userNav.items} navTitle={userNav.header}>
            <div className="d-flex flex-column w-100">
                <PageHeader title={'User Groups'} />
                <div className='px-4 py-2'>
                    {/* {(visible || (editMode && editUserGroupId)) && (
                        <AddUserGroup
                            visible={visible}
                            editUserGroupId={editUserGroupId}
                            editMode={editMode}
                            userGroupDetail={userGroupDetail}
                            handleClose={handleClose}
                            fetchUserGroups={fetchUserGroupsProps}
                            setUserGroupDetail={setUserGroupDetail}
                            canCreate={canCreate}
                            canUpdate={canUpdate}
                            canDelete={canDelete}
                        />
                    )} */}
                    {isLoading ? (
                        <Loader />
                    ) : (
                        <>
                            <Toast ref={toast} />
                            <div className="user-group">
                                <InfiniteScroll
                                    dataLength={userGroupList.length}
                                    next={handleLoadMore}
                                    hasMore={hasMore}
                                    className="card-container"
                                >
                                    {/* {canCreate && <Card
                                        title="User Group"
                                        header={<Icon icon="tabler:plus" style={{ color: 'black' }} width={70} height={70} />}
                                        className="card"
                                        onClick={() => setVisible(true)}
                                    />} */}
                                    {userGroupList.length !== 0 && renderCardsInRows()}
                                </InfiniteScroll>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Layout2>
    );
};

export default UserGroup;
